import VideoCameraFront from '@mui/icons-material/VideoCameraFront'
import { useEffect, useRef } from 'react'
import useElementDimensions from 'src/customHooks/customHooks'
import { BOOKING_STATUSES, BOOKING_PAYMENT_STATUSES } from 'src/consumer/constants'

const BookedSlotHeader = ({ 
  bookedSlot, 
  apptCalendarSettings, 
  styles,
  forMentor,
  hidePreviousTherapyReportsButton
}) => {
  const leftStripRef = useRef(null)
  const leftStripTextRef = useRef(null)

  const {
    dimensions: leftStripDimensions,
    refresh: refreshLeftStripDim,
  } = useElementDimensions({ updateOnScroll: false })

  const {
    dimensions: leftStripTextDimensions,
    refresh: refreshLeftStripTextDim,
  } = useElementDimensions({ updateOnScroll: false })

  const isBookedSlotBlockedForPayment =
    bookedSlot?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
    bookedSlot?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING

  // Determine if appointment number should be shown vertically
  let isShowingVerticalApptNumber = true
  if (leftStripDimensions?.height <= leftStripTextDimensions?.height) {
    isShowingVerticalApptNumber = false
  }

  if (apptCalendarSettings?.showAppointmentNumberHorizontally) {
    isShowingVerticalApptNumber = false
  }

  useEffect(() => {
    refreshLeftStripDim()
    refreshLeftStripTextDim()
  }, [bookedSlot, refreshLeftStripDim, refreshLeftStripTextDim])

  const textStyle = {
    transform: isShowingVerticalApptNumber ? 'rotate(180deg)' : '',
    writingMode: isShowingVerticalApptNumber ? 'vertical-lr' : 'unset',
    color: styles?.leftStripTextColor || '#FFFFFF', // Use calculated text color for purple background
    fontWeight: 700,
    fontSize: '13px',
    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)', // Add subtle shadow for better visibility
  }

  const headerStyle = {
    ...styles.leftStripStyle,
    marginRight: forMentor && !hidePreviousTherapyReportsButton && bookedSlot?.therapyPatient 
      ? '0px' 
      : '8px',
  }

  // For BLOCKED text, also check if height is too small (less than 50px) to show horizontally
  const shouldShowBlockedHorizontal = leftStripDimensions?.height < 50

  return (
    <div ref={leftStripRef} style={headerStyle}>
      {isBookedSlotBlockedForPayment ? (
        <span 
          ref={leftStripTextRef} 
          style={{
            ...textStyle,
            transform: shouldShowBlockedHorizontal ? 'none' : 'rotate(180deg)',
            writingMode: shouldShowBlockedHorizontal ? 'unset' : 'vertical-lr',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '1px',
            color: '#ffffff',
            textTransform: 'uppercase',
            padding: shouldShowBlockedHorizontal ? '4px 6px' : '4px 2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.7), 0 0 2px rgba(0, 0, 0, 0.5)',
          }}
        >
          BLOCKED
        </span>
      ) : (
        <>
          {bookedSlot?.meetingSrc === 'aumhum' ? (
            <span>
              <VideoCameraFront sx={{ 
                fontSize: '18px', 
                color: '#ffffff',
                filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))',
              }} />
            </span>
          ) : (
            <span ref={leftStripTextRef} style={textStyle}>
              {bookedSlot?.appointmentNumber}
            </span>
          )}
        </>
      )}
    </div>
  )
}

export default BookedSlotHeader